export const ToothMascot = ({ className = "", mood = "happy" }) => (
  <svg viewBox="0 0 120 130" className={className} aria-hidden="true">
    <path
      d="M60 14c-10-9-30-10-40 2-11 13-8 33-2 47 4 10 5 22 7 34 2 13 6 25 14 25 9 0 9-20 13-30 2-5 4-7 8-7s6 2 8 7c4 10 4 30 13 30 8 0 12-12 14-25 2-12 3-24 7-34 6-14 9-34-2-47-10-12-30-11-40-2z"
      fill="#ffffff" stroke="#1e293b" strokeWidth="4" strokeLinejoin="round"
    />
    <path d="M28 30c4-8 13-10 19-7" stroke="#bae6fd" strokeWidth="6" strokeLinecap="round" fill="none" />
    <g className="animate-blink">
      <ellipse cx="45" cy="56" rx="5" ry="7" fill="#1e293b" />
      <ellipse cx="75" cy="56" rx="5" ry="7" fill="#1e293b" />
    </g>
    <circle cx="47" cy="53" r="1.8" fill="#fff" />
    <circle cx="77" cy="53" r="1.8" fill="#fff" />
    <ellipse cx="34" cy="70" rx="7" ry="4" fill="#ff6b6b" opacity=".45" />
    <ellipse cx="86" cy="70" rx="7" ry="4" fill="#ff6b6b" opacity=".45" />
    {mood === "wow" ? (
      <ellipse cx="60" cy="74" rx="6" ry="7" fill="#1e293b" />
    ) : (
      <path d="M48 70c5 8 19 8 24 0" stroke="#1e293b" strokeWidth="4" strokeLinecap="round" fill="none" />
    )}
  </svg>
);
